// This stub creates a vue.js event bus. It is useful in some cases where
// events need to be passed between objects but their relationship is not
// necessarily direct parent-child.

// More info:
//   https://alligator.io/vuejs/global-event-bus/

import Vue from "vue";
export const EventBus = new Vue();



// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/event-bus.js